export const Action = {
  hidePromptCompleteService: "hidePromptCompleteService",
  clickSystemMessage: "clickSystemMessage",
  setSelectedMenu: "setSelectedMenu",
  clickSubMenu: "clickSubMenu",
  onNotifyCreateSandbox: "onNotifyCreateSandbox",
  onNotifyApplySandbox: "onNotifyApplySandbox",
  tenantId: "tenantId",
};

export const Mutation = {
  SET_STATE_OF_CHATS_WITH_STAFF: "STATE_OF_CHATS_WITH_STAFF",
  SET_DISPLAY_PROMPT_COMPLETE_SERVICE: "DISPLAY_PROMPT_COMPLETE_SERVICE",
  SET_IS_TAB_RETURN_REMINDER_HIDDEN: "SET_IS_TAB_RETURN_REMINDER_HIDDEN",
  SET_CHECKIN: "SET_CHECKIN",
  SET_ADMIN_CHANGED: "SET_ADMIN_CHANGED",
  SET_ADMIN_SUB_CHANGED: "SET_ADMIN_SUB_CHANGED",
  SET_CURRENT_GROUP_ID: "SET_CURRENT_GROUP_ID",
  SET_BOT_DICT_UPDATED_IDX: "BOT_DICT_UPDATED_IDX",
  SET_MENU_PATH: "SET_MENU_PATH",
  SET_OPEN_GUEST_INPUT: "OPEN_GUEST_INPUT",
  SET_BIZ_FACILITY: "BIZ_FACILITY",
  SET_SELECTED_MENU: "SELECTED_MENU",
  SET_PREVIOUS_MENU: "PREVIOUS_MENU",
  SET_TRIPADVISOR_DOMAIN: "TRIPADVISOR_DOMAIN",
  SET_OPEN_HOTEL_MENU: "OPEN_HOTEL_MENU",
  SET_COUPONS: "SET_COUPONS",
  SET_LOCK_SESSION: "SET_LOCK_SESSION",
  SET_TENANT_ID: "SET_TENANT_ID",
  SET_TENANT_LANG_CD: "SET_TENANT_LANG_CD",
  SET_ADMIN_TENANT_FLG: "SET_ADMIN_TENANT_FLG",
  SET_INPUT_ROOM_NO_BEFORE_CONVERSATION: "SET_INPUT_ROOM_NO_BEFORE_CONVERSATION",
  SET_TENANT_INFO: "SET_TENANT_INFO",
  SET_STORE_LOCATION_INFO: "SET_STORE_LOCATION_INFO",
  SET_CMS_COUPON_OPTION: "SET_CMS_COUPON_OPTION",
  STOP_CHECKING_IMPORT_PROCESS: "STOP_CHECKING_IMPORT_PROCESS",
  SET_ICON_COLOR: "SET_ICON_COLOR",
};
